<template>
  <div class="container-fluid">
    <div class="row">
      <div class="col-md-12">
        <div class="overview-wrap">
          <h2 class="title-1">Дэд меню үүсгэх</h2>
        </div>
      </div>
    </div>

    <div class="row my-3">
      <div class="card w-100">
        <div class="card-header">
          <div class="row form-group">
            <div class="col col-md-1">
              <label for="text-input" class="form-control-label">Нэр*</label>
            </div>
            <div class="col-12 col-md-4">
              <input
                type="text"
                id="text-input"
                name="text-input"
                class="form-control"
                v-on:input="onChangeHandler('name', $v.name)"
                :class="{ 'form-control is-invalid': $v.name.$error }"
                v-model="name"
              >
              <div class="invalid-feedback">{{ this.getErrorMsg('name')[0] }}</div>
            </div>

            <div class="col col-md-1 offset-1">
              <label for="text-input" class="form-control-label">Бүтэц*</label>
            </div>
            <div class="col-12 col-md-5">
              <select
                name="select"
                id="select"
                class="form-control"
                v-on:input="onChangeHandler('layout', $v.layout)"
                :class="{ 'form-control is-invalid': $v.layout.$error }"
                v-model="layout"
              >
                <option disabled selected value>Сонгох</option>
                <option value="1">Article 1 column</option>
                <option value="2">Article 2 column</option>
                <option value="3">Card list</option>
                <option value="4">Branch list</option>
                <option value="5">HTML content</option>
              </select>
              <div class="invalid-feedback">{{ this.getErrorMsg('layout')[0] }}</div>
            </div>
          </div>
        </div>
        <div class="card-body">
          <div class="default-tab">
            <div class="d-flex">
              <div
                :class="[{ 'tab--selected' : languageTab === 'MN', 'tab--invalid': mnTabError && languageTab !== 'MN' }, 'nav-link tab']"
                @click="languageTab = 'MN'"
              >MON</div>
              <div
                :class="[{ 'tab--selected' : languageTab === 'EN', 'tab--invalid': enTabError && languageTab !== 'EN' }, 'nav-link tab']"
                @click="languageTab = 'EN'"
              >ENG</div>
            </div>

            <br>
            <!-- MN tab -->
            <div v-if="languageTab === 'MN'">
              <div class="row mt-3 form-group">
                <div class="card w-100" :class="{ 'border-danger': $v.imagesmon.$error }">
                  <div class="card-header d-flex justify-content-between">
                    <p>Slider</p>
                    <button @click="imageOpenDialog('image-input-mon')" class="btn btn-primary">
                      <i class="fas fa-plus"></i>
                    </button>
                    <input
                      type="file"
                      accept="image/*"
                      id="image-input-mon"
                      class="btn btn-primary"
                      @change="onImageInput($event, true)"
                      hidden
                    >
                  </div>
                  <div v-if="imagesmon.length > 0" class="card-body d-flex flex-row flex-wrap">
                    <div
                      v-for="(image, i) in imagesmon"
                      :key="i"
                      class="justify-content-start mx-2 mb-3 height-150"
                    >
                      <img v-bind:src="image" class="img-thumbnail mh-100" alt>
                      <button @click="removeImg(image, true)" class="close img-close-btn">
                        <span>&times;</span>
                      </button>
                    </div>
                  </div>
                  <div class="card-footer">
                    <font
                      v-if="$v.imagesmon.$error"
                      size="2"
                      class="text-danger"
                    >{{ this.getErrorMsg('imageList.0')[0] }}</font>
                  </div>
                </div>
              </div>
              <div class="row mt-3 form-group">
                <div class="col col-md-2">
                  <label for="text-input" class="form-control-label">Гарчиг*</label>
                </div>
                <div class="col-12 col-md-10">
                  <input
                    type="text"
                    id="text-input"
                    name="text-input"
                    class="form-control"
                    v-on:input="onChangeHandler('title.0', $v.mntitle)"
                    :class="{ 'form-control is-invalid': $v.mntitle.$error }"
                    v-model="mntitle"
                  >
                  <div class="invalid-feedback">{{ this.getErrorMsg('title.0')[0] }}</div>
                </div>
              </div>
              <div class="row mt-3 form-group">
                <div class="col col-md-2">
                  <label for="text-input" class="form-control-label">Тайлбар</label>
                </div>
                <div class="col-12 col-md-10">
                  <textarea-autosize
                    class="form-control"
                    v-on:input="onChangeHandler('description.0', $v.mndesc)"
                    :class="{ 'is-invalid': $v.mndesc.$error }"
                    v-model="mndesc"
                  ></textarea-autosize>
                  <div class="invalid-feedback">{{ this.getErrorMsg('description.0')[0] }}</div>
                </div>
              </div>
            </div>
            <!-- EN tab -->
            <div v-else-if="languageTab === 'EN'">
              <div class="row mt-3 form-group">
                <div class="card w-100" :class="{ 'border-danger': $v.imageseng.$error }">
                  <div class="card-header d-flex justify-content-between">
                    <p>Slider</p>
                    <button @click="imageOpenDialog('image-input-eng')" class="btn btn-primary">
                      <i class="fas fa-plus"></i>
                    </button>
                    <input
                      type="file"
                      accept="image/*"
                      id="image-input-eng"
                      class="btn btn-primary"
                      @change="onImageInput($event, false)"
                      hidden
                    >
                  </div>
                  <div v-if="imageseng.length > 0" class="card-body d-flex flex-row flex-wrap">
                    <div
                      v-for="(image, i) in imageseng"
                      :key="i"
                      class="justify-content-start mx-2 mb-3 height-150"
                    >
                      <img v-bind:src="image" class="img-thumbnail mh-100" alt>
                      <button @click="removeImg(image, false)" class="close img-close-btn">
                        <span>&times;</span>
                      </button>
                    </div>
                  </div>
                  <div class="card-footer">
                    <font
                      v-if="$v.imageseng.$error"
                      size="2"
                      class="text-danger"
                    >{{ this.getErrorMsg('imageList.1')[0] }}</font>
                  </div>
                </div>
              </div>
              <div class="row mt-3 form-group">
                <div class="col col-md-2">
                  <label for="text-input" class="form-control-label">Гарчиг{{ notOptional }}</label>
                </div>
                <div class="col-12 col-md-10">
                  <input
                    type="text"
                    id="text-input"
                    name="text-input"
                    class="form-control"
                    v-on:input="onChangeHandler('title.1', $v.entitle)"
                    :class="{ 'form-control is-invalid': $v.entitle.$error }"
                    v-model="entitle"
                  >
                  <div class="invalid-feedback">{{ this.getErrorMsg('title.1')[0] }}</div>
                </div>
              </div>
              <div class="row mt-3 form-group">
                <div class="col col-md-2">
                  <label for="text-input" class="form-control-label">Тайлбар</label>
                </div>
                <div class="col-12 col-md-10">
                  <textarea-autosize
                    class="form-control"
                    v-on:input="onChangeHandler('description.1', $v.endesc)"
                    :class="{ 'is-invalid': $v.endesc.$error }"
                    v-model="endesc"
                  ></textarea-autosize>
                  <div class="invalid-feedback">{{ this.getErrorMsg('description.1')[0] }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="card-footer d-flex justify-content-end">
          <router-link to="/submenu">
            <button type="submit" class="btn btn-primary mx-2">Буцах</button>
          </router-link>
          <button @click="onSubmit" type="submit" class="btn btn-success">
            <i class="fa fa-dot-circle-o"></i> Хадгалах
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<style>
.height-150 {
  height: 150px;
}

.img-close-btn {
  position: absolute;
  margin-left: -20px;
  color: green;
}
</style>

<script>
import MenuService from "@/services/MenuService";
import Form from "@/mixins/Form.js";
import ImageUploadService from "@/services/ImageUploadService";

export default {
  name: "SubmenuCreate",

  mixins: [Form],

  computed: {
    mnTabError() {
      return (
        this.$v.imagesmon.$error ||
        this.$v.mndesc.$error ||
        this.$v.mntitle.$error
      );
    },

    enTabError() {
      return (
        this.$v.imageseng.$error ||
        this.$v.endesc.$error ||
        this.$v.entitle.$error
      );
    },

    notOptional() {
      return this.hasEngdata() ? "*" : "";
    }
  },

  data() {
    return {
      name: "",
      layout: "",
      mntitle: "",
      entitle: "",
      mndesc: "",
      endesc: "",
      imagesmon: [],
      imageseng: []
    };
  },

  validations: {
    name: {
      serverFailed: function() {
        return !this.hasServerError("name");
      }
    },
    layout: {
      serverFailed: function() {
        return !this.hasServerError("layout");
      }
    },
    mntitle: {
      serverFailed: function() {
        return !this.hasServerError("title.0");
      }
    },
    entitle: {
      serverFailed: function() {
        return !this.hasServerError("title.1");
      }
    },
    mndesc: {
      serverFailed: function() {
        return !this.hasServerError("description.0");
      }
    },
    endesc: {
      serverFailed: function() {
        return !this.hasServerError("description.1");
      }
    },
    imagesmon: {
      serverFailed: function() {
        return !this.hasServerError("imageList.0");
      }
    },
    imageseng: {
      serverFailed: function() {
        return !this.hasServerError("imageList.1");
      }
    }
  },

  methods: {
    serverRequest: MenuService.createSubmenu,

    successHandler(response) {
      if (response.data.payload.toast != null)
        this.showToast(response.data.payload.toast);

      this.$router.push("/submenu");
    },

    createJsonData() {
      let data = JSON.parse("{}");
      data.parentId = this.$route.params.parentId;
      data.name = this.name;
      data.layout = this.layout;
      data.contents = [];

      let mncontent = JSON.parse("{}");
      mncontent.language = 1;
      mncontent.title = this.mntitle;
      if (this.mndesc != "") mncontent.description = this.mndesc;
      if (this.imagesmon.length > 0) mncontent.imageList = this.imagesmon;
      data.contents.push(mncontent);

      if (this.hasEngdata()) {
        let encontent = JSON.parse("{}");
        encontent.language = 2;
        encontent.title = this.entitle;
        if (this.endesc != "") encontent.description = this.endesc;
        if (this.imageseng.length > 0) encontent.imageList = this.imageseng;
        data.contents.push(encontent);
      }
      return data;
    },

    hasEngdata() {
      return (
        this.entitle != "" || this.imageseng.length > 0 || this.endesc != ""
      );
    },

    onImageInput(event, isMon) {
      if (event.target.files[0] != null) {
        this.$store.dispatch("setLoading", true);
        const data = new FormData();
        data.append("image", event.target.files[0]);

        ImageUploadService.uploadImage(data).then(response => {
          if (isMon) this.imagesmon.push(response.data);
          else this.imageseng.push(response.data);

          this.$store.dispatch("setLoading", false);
        });
      }
    },

    imageOpenDialog(elementid) {
      document.getElementById(elementid).click();
    },

    removeImg(image, isMon) {
      if (isMon) {
        this.onChangeHandler("imageList.0", this.$v.imagesmon);
        let index = this.imagesmon.indexOf(image);
        if (index > -1) this.imagesmon.splice(index, 1);
      } else {
        this.onChangeHandler("imageList.1", this.$v.imageseng);
        let index = this.imageseng.indexOf(image);
        if (index > -1) this.imageseng.splice(index, 1);
      }
    }
  }
};
</script>
